import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api";
import AuthContext from "../../context/AuthContext";

export default function EditBlog() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const [title, setTitle] = useState("");
  const [textContent, setTextContent] = useState("");
  const [oldImage, setOldImage] = useState("");
  const [newImage, setNewImage] = useState(null);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    api.get(`/api/blog/${id}`)
      .then((res) => {
        const blog = res.data;
        setTitle(blog.title);
        setTextContent(blog.textContent);
        setOldImage(blog.imageFileName);
      })
      .catch((err) => console.error("Error loading blog:", err));
  }, [id]);

  // ⭐ Identify admin or normal user
  const isAdmin = user.role === "ROLE_ADMIN";

  // ⭐ Correct API URLs for text update
  const textUpdateURL = isAdmin
    ? `/api/blog/text/${id}`
    : `/api/blog/user/text/${id}?userType=${user.customerType}&email=${user.username}`;

  // ⭐ Correct API URLs for image update
  const imageUpdateURL = isAdmin
    ? `/api/blog/image/${id}`
    : `/api/blog/user/image/${id}?userType=${user.customerType}&email=${user.username}`;

  const updateBlog = async (e) => {
    e.preventDefault();

    try {
      // ✔ Update text
      await api.put(textUpdateURL, {
        title,
        textContent,
      });

      // ✔ Update image if new image chosen
      if (newImage) {
        const formData = new FormData();
        formData.append("file", newImage);

        await api.put(imageUpdateURL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      alert("Blog updated successfully!");
      navigate("/admin/roleblogs");

    } catch (err) {
      console.error("Error updating blog:", err);
      alert("Error updating blog");
    }
  };

  return (
    <div className="container mt-4">

      <h3 className="fw-bold text-primary mb-4">✏ Edit Blog</h3>

      <form onSubmit={updateBlog} className="card p-4 shadow border-0 rounded-4">

        {/* Title */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Blog Title</label>
          <input
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        {/* Content */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Content</label>
          <textarea
            className="form-control"
            rows="6"
            value={textContent}
            onChange={(e) => setTextContent(e.target.value)}
            required
          />
        </div>

        {/* Current Image */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Current Image</label>
          <br />
          {oldImage ? (
            <img
              src={`${BASE_URL}/api/blog/image/${oldImage}`}
              alt="blog"
              width="200"
              className="rounded shadow-sm mb-2"
            />
          ) : (
            <p className="text-muted">No Image</p>
          )}
        </div>

        {/* Upload New Image */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Change Image</label>
          <input
            type="file"
            className="form-control"
            onChange={(e) => setNewImage(e.target.files[0])}
          />
        </div>

        <button className="btn btn-success px-4 rounded-pill">
          Save Changes
        </button>
      </form>
    </div>
  );
}
